import * as Shape from './shape';
import * as Registry from './registry';
export * from './model';
export * from './view';
export * from './graph';
export * from './config';
export * from './util';
export * from '@antv/x6-common';
export * from '@antv/x6-geometry';
export { Shape, Registry };
//# sourceMappingURL=index.js.map